/* "Also add": voegt een bijpassend product toe als eigen regel in de winkelwagen.

   INKLAPPEN MET EEN PIJLTJE RECHTSBOVEN (Iris, 2026-10-09). Is een product
   opengeklapt, dan verdwijnt de knop "Choose options" en staat er rechtsboven in
   het kader een pijltje omhoog (zonder tekst) waarmee je het weer inklapt. Dicht
   is de knop terug, met de tekst "Choose options" of "Add another" als het
   product al in de winkelwagen zit. Zie setOpen; de opmaak zet ensureStyle
   eenmalig in de pagina (de CSS-bestanden zijn te groot om voor drie regels
   opnieuw weg te schrijven).

   GEEN OVERZICHT EN GEEN GEKOPIEERDE TEKSTEN MEER (besluit Iris, 2026-10-09).
   Het grijze blok met Fun facts / Name / Date / Font onder "We use the same
   details as above..." is weg, en de bijproduct-regel krijgt die teksten ook
   niet meer mee. Iris maakt het ontwerp van het bijproduct aan de hand van het
   hoofdproduct; de regel draagt alleen 'Match design: Same as <hoofdproduct>'
   plus de opties die het paneel zelf vraagt (maat, aantal, vorm). Daarvoor is
   INHERIT_KEYS leeg en zet showSummary het overzicht altijd verborgen. Wil je
   het terug: zet de namen weer in INHERIT_KEYS ('Title text', 'Text',
   'Fun facts', 'Name(s)', 'Names', 'Date', 'Font', 'Text color',
   'Special requests or details') en herstel showSummary.

   TWEE STANDEN, gezet door blocks/also-add.liquid:

   inherit (standaard) - het paneel toont alleen de opties uit panel_options,
     standaard maat en aantal. Het ontwerp volgt het hoofdproduct.

   own - het paneel toont de eigen personalisatievelden van dat product.

   LEES DE VELDEN VAN HET HOOFDPRODUCT VIA form.elements, NIET VIA querySelector.
   De personalisatievelden staan niet binnen het <form>; ze hangen eraan met het
   form-attribuut omdat ze elders op de pagina gerenderd worden.

   HET PANEEL VOLGT DE REGELS VAN HET PRODUCTFORMULIER: kun je het hoofdproduct
   op dit moment toevoegen, dan kun je dit er ook bij doen (checkValidity).

   EEN TOEGEVOEGDE REGEL BLIJFT TOEGEVOEGD: groene rand, bijschrift bij de prijs,
   knop "Add another", tot de pagina opnieuw laadt.

   VARIANTOPTIES DIE HET PANEEL NIET VRAAGT worden overgenomen op naam
   (syncHiddenOptions), bijvoorbeeld Foil finish.

   HET GEUPLOADE BESTAND GAAT NIET MEE naar de bijproduct-regel; 'Match design'
   verwijst naar het hoofdproduct.

   GEEN BACKSLASHES IN DIT BESTAND. Dit bestand wordt via de theme-API
   weggeschreven en daar zijn backslashes al een keer verdubbeld.

   Verder twee dingen om te onthouden:

   1. De veldnamen in het paneel dragen een prefix (aa0__, aa1__). De prefix
      gaat er hier weer af, zodat de property op de bestelling exact de nette
      naam is.

   2. detail moet in de constructor van het CustomEvent mee, niet erna. Horizon's
      luisteraars lezen:
        cart-icon.js            -> detail.data.itemCount  (ontbreekt = teller op 0)
        component-cart-items.js -> detail.data.sections   (ontbreekt = TypeError)
        cart-drawer.js          -> detail.resource.item_count */
(function () {
  'use strict';
  if (customElements.get('also-add')) return;

  var PROPERTY_OPEN = 'properties[';
  var CHEVRON_UP = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 15 6-6 6 6"/></svg>';

  /* Leeg sinds 2026-10-09: er wordt geen personalisatie meer gekopieerd. */
  var INHERIT_KEYS = [];

  function ensureStyle() {
    if (document.getElementById('also-add-collapse-style')) return;
    var style = document.createElement('style');
    style.id = 'also-add-collapse-style';
    style.textContent =
      '.also-add .also-add__item { position: relative; }' +
      '.also-add .also-add__collapse { position: absolute; top: 0.45rem; right: 0.45rem; display: none; align-items: center; justify-content: center; width: 2.25rem; height: 2.25rem; padding: 0; color: var(--color-foreground); background: transparent; border: 0; border-radius: 50%; cursor: pointer; }' +
      '.also-add .also-add__collapse:hover { background-color: rgb(var(--color-foreground-rgb) / 0.07); }' +
      '.also-add .also-add__collapse:focus-visible { outline: 2px solid var(--color-foreground); outline-offset: 2px; }' +
      '.also-add .also-add__item.is-open .also-add__collapse { display: flex; }' +
      '.also-add .also-add__item.is-open [data-also-add-trigger] { display: none; }' +
      '.also-add .also-add__item.is-open .also-add__info { padding-right: 2.5rem; }';
    document.head.appendChild(style);
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: currency
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* 'properties[Napkin color]' -> 'Napkin color'. Leeg als het geen property is. */
  function propertyKey(name) {
    if (!name || name.indexOf(PROPERTY_OPEN) !== 0) return '';
    if (name.charAt(name.length - 1) !== ']') return '';
    return name.slice(PROPERTY_OPEN.length, name.length - 1);
  }

  /* Alle bedieningselementen met deze naam die aan het formulier hangen, ook de
     velden die er met form="..." aan gekoppeld zijn en er niet in staan. */
  function fieldsNamed(form, name) {
    var out = [];
    if (!form || !form.elements) return out;
    for (var i = 0; i < form.elements.length; i++) {
      if (form.elements[i].name === name) out.push(form.elements[i]);
    }
    return out;
  }

  function firstValue(form, name) {
    var fields = fieldsNamed(form, name);
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      if (field.disabled) continue;
      if (field.type === 'file') continue;
      if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) continue;
      if (!field.value) continue;
      return field.value;
    }
    return '';
  }

  /* Oude en nieuwe waardenamen (test 2026-10-09) betekenen hetzelfde:
     'Yes · Metallic foil' = 'Metallic foil', 'No · Standard print' = 'No foil'.
     Bestaat de waarde van het hoofdproduct niet bij het bijproduct, dan zoeken
     we de waarde met dezelfde betekenis. */
  function foilMeaning(value) {
    var text = String(value || '').toLowerCase();
    if (text.indexOf('yes') === 0 || text.indexOf('metallic') !== -1) return 'yes';
    if (text.indexOf('no') === 0) return 'no';
    return '';
  }

  function sameValue(product, position, value) {
    if (!product || !product.variants || isNaN(position)) return value;
    var values = [];
    product.variants.forEach(function (variant) {
      var v = variant.values[position];
      if (values.indexOf(v) === -1) values.push(v);
    });
    if (values.indexOf(value) !== -1) return value;
    var meaning = foilMeaning(value);
    if (!meaning) return value;
    for (var i = 0; i < values.length; i++) {
      if (foilMeaning(values[i]) === meaning) return values[i];
    }
    return value;
  }

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (node) {
      var id = node.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  class AlsoAdd extends HTMLElement {
    connectedCallback() {
      ensureStyle();
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));

      /* De klant kan boven nog van alles omzetten terwijl een paneel openstaat. */
      var self = this;
      this.onParentChange = function () { self.syncAllPanels(); };
      document.addEventListener('variant:update', this.onParentChange);
      document.addEventListener('change', this.onParentChange);
      document.addEventListener('input', this.onParentChange);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:update', this.onParentChange);
      document.removeEventListener('change', this.onParentChange);
      document.removeEventListener('input', this.onParentChange);
    }

    form() {
      return document.getElementById(this.dataset.formId) ||
             document.querySelector('form[action*="/cart/add"]');
    }

    item(index) {
      return this.querySelector('[data-also-add-item="' + index + '"]');
    }

    panel(index) {
      return this.querySelector('[data-also-add-panel="' + index + '"]');
    }

    trigger(index) {
      return this.querySelector('[data-also-add-trigger="' + index + '"]');
    }

    data(index) {
      var node = this.querySelector('[data-also-add-data="' + index + '"]');
      if (!node) return null;
      try { return JSON.parse(node.textContent); } catch (e) { return null; }
    }

    parentData() {
      var node = this.querySelector('[data-also-add-parent]');
      if (!node) return null;
      try { return JSON.parse(node.textContent); } catch (e) { return null; }
    }

    /* Optienaam (kleine letters) -> waarde die op het hoofdproduct gekozen is. */
    parentSelection() {
      var out = {};
      var info = this.parentData();
      var form = this.form();
      if (!info || !form) return out;

      var id = firstValue(form, 'id');
      var values = id ? info.variants[id] : null;
      if (!values) return out;

      info.options.forEach(function (name, position) {
        if (values[position]) out[String(name).toLowerCase()] = values[position];
      });
      return out;
    }

    /* Zou het hoofdproduct op dit moment toegevoegd kunnen worden? */
    parentReady() {
      var form = this.form();
      if (!form || typeof form.checkValidity !== 'function') return true;
      return form.checkValidity();
    }

    onClick(event) {
      var collapse = event.target.closest('[data-also-add-collapse]');
      if (collapse) {
        this.toggle(collapse.getAttribute('data-also-add-collapse'));
        return;
      }
      var trigger = event.target.closest('[data-also-add-trigger]');
      if (trigger) {
        this.toggle(trigger.getAttribute('data-also-add-trigger'));
        return;
      }
      var submit = event.target.closest('[data-also-add-submit]');
      if (submit) {
        this.submit(submit.getAttribute('data-also-add-submit'));
      }
    }

    onChange(event) {
      if (!event.target.matches('[data-also-add-option]')) return;
      var panel = event.target.closest('[data-also-add-panel]');
      if (panel) this.refresh(panel.getAttribute('data-also-add-panel'));
    }

    syncAllPanels() {
      var self = this;
      this.querySelectorAll('[data-also-add-panel]').forEach(function (panel) {
        if (panel.hidden) return;
        var index = panel.getAttribute('data-also-add-panel');
        self.syncHiddenOptions(panel);
        self.showSummary(panel);
        self.refresh(index);

        /* De melding hoort weg zodra het formulier boven compleet is. */
        if (panel.dataset.inherit === 'true' && self.parentReady()) {
          self.setError(panel, '');
        }
      });
    }

    /* Opties die het paneel niet vraagt volgen het hoofdproduct, op naam. */
    syncHiddenOptions(panel) {
      var selection = this.parentSelection();
      var product = this.data(panel.getAttribute('data-also-add-panel'));
      panel.querySelectorAll('input[data-option-name]').forEach(function (field) {
        var name = String(field.getAttribute('data-option-name')).toLowerCase();
        if (!selection[name]) return;
        var position = parseInt(field.getAttribute('data-also-add-option'), 10);
        field.value = sameValue(product, position, selection[name]);
      });
    }

    /* Open: knop weg, pijltje rechtsboven. Dicht: knop terug met "Choose options"
       of "Add another". Het pijltje wordt de eerste keer aangemaakt. */
    setOpen(index, open) {
      var item = this.item(index);
      var trigger = this.trigger(index);
      if (!item) return;

      var collapse = item.querySelector('[data-also-add-collapse]');
      if (!collapse) {
        collapse = document.createElement('button');
        collapse.type = 'button';
        collapse.className = 'also-add__collapse';
        collapse.setAttribute('data-also-add-collapse', index);
        collapse.setAttribute('aria-label', 'Collapse');
        collapse.innerHTML = CHEVRON_UP;
        item.appendChild(collapse);
      }

      item.classList.toggle('is-open', open);
      if (!trigger) return;
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

      var target = trigger.querySelector('[data-also-add-trigger-label]');
      if (!target) return;
      if (!trigger.hasAttribute('data-label-closed')) {
        trigger.setAttribute('data-label-closed', target.textContent);
      }
      var added = item.classList.contains('is-added');
      var swap = trigger.getAttribute('data-label-added');
      target.textContent = (added && swap) ? swap : trigger.getAttribute('data-label-closed');
      if (!open && document.activeElement === collapse) trigger.focus();
    }

    toggle(index) {
      var panel = this.panel(index);
      if (!panel) return;

      var opening = panel.hidden;
      panel.hidden = !opening;
      this.setOpen(index, opening);

      if (opening) {
        this.syncHiddenOptions(panel);
        if (panel.dataset.inherit === 'true') {
          this.showSummary(panel);
        } else {
          this.prefill(panel);
        }
        this.refresh(index);
      }
    }

    /* Leest van het hoofdformulier wat in INHERIT_KEYS staat (nu niets). */
    inherited() {
      var form = this.form();
      var out = {};
      if (!form) return out;

      INHERIT_KEYS.forEach(function (key) {
        var value = firstValue(form, PROPERTY_OPEN + key + ']');
        if (value) out[key] = value;
      });

      return out;
    }

    /* Het grijze overzicht staat altijd uit (Iris, 2026-10-09). De zin
       "We use the same details as above..." komt uit het blok en blijft staan. */
    showSummary(panel) {
      var node = panel.querySelector('[data-also-add-summary]');
      if (!node) return;
      node.innerHTML = '';
      node.hidden = true;
    }

    /* Vult Text en Font één keer voor met wat op het hoofdproduct staat, zodat
       "hetzelfde ontwerp" het uitgangspunt is en de klant het kan aanpassen.
       Alleen in de stand met eigen velden. */
    prefill(panel) {
      if (panel.dataset.prefilled) return;
      panel.dataset.prefilled = 'true';

      var form = this.form();
      if (!form) return;
      var prefix = panel.dataset.keyPrefix || '';

      ['Text', 'Font'].forEach(function (key) {
        var value = firstValue(form, PROPERTY_OPEN + key + ']');
        var target = panel.querySelector('[name="' + PROPERTY_OPEN + prefix + key + ']"]');
        if (!value || !target || target.value) return;

        if (target.tagName === 'SELECT') {
          var match = Array.prototype.filter.call(target.options, function (option) {
            return option.value === value;
          })[0];
          if (match) target.value = value;
          return;
        }
        target.value = value;
      });
    }

    match(index) {
      var product = this.data(index);
      var panel = this.panel(index);
      if (!product || !panel) return null;

      var controls = panel.querySelectorAll('[data-also-add-option]');
      if (!controls.length) {
        return product.variants.filter(function (variant) { return variant.available; })[0] || null;
      }

      var chosen = [];
      controls.forEach(function (control) {
        chosen[parseInt(control.getAttribute('data-also-add-option'), 10)] = control.value;
      });

      return product.variants.filter(function (variant) {
        return chosen.every(function (value, position) { return variant.values[position] === value; });
      })[0] || null;
    }

    refresh(index) {
      var panel = this.panel(index);
      if (!panel) return;
      var variant = this.match(index);
      var price = panel.querySelector('[data-also-add-price]');
      var submit = panel.querySelector('[data-also-add-submit]');

      if (price) price.textContent = variant ? money(variant.price) : '';
      if (submit) submit.disabled = !variant || !variant.available;
    }

    setError(panel, message) {
      var node = panel.querySelector('[data-also-add-error]');
      if (!node) return;
      node.textContent = message || '';
      node.hidden = !message;
    }

    /* Blijvende markering op de regel: groene rand en bijschrift bij de prijs.
       De knoptekst ("Add another") zet setOpen bij het dichtklappen. */
    markAdded(index) {
      var item = this.item(index);
      if (!item) return;

      var count = parseInt(item.dataset.addedCount || '0', 10) + 1;
      item.dataset.addedCount = count;
      item.classList.add('is-added');

      var badge = item.querySelector('[data-also-add-added]');
      if (badge) {
        var label = this.dataset.addedBadge || 'In your cart';
        badge.textContent = count > 1 ? ('✓ ' + label + ' (' + count + ')') : ('✓ ' + label);
        badge.hidden = false;
      }
    }

    /* Alle velden in dit paneel, met de prefix eraf, plus wat overgenomen wordt.
       Het paneel wint: staat er in de eigen-velden-stand iets ingevuld, dan gaat
       dat voor. */
    collect(panel) {
      var prefix = panel.dataset.keyPrefix || '';
      var properties = {};

      if (panel.dataset.inherit === 'true') {
        properties = this.inherited();
      }

      panel.querySelectorAll('[name^="properties["]').forEach(function (field) {
        if (field.type === 'file') return;
        if (field.disabled) return;
        if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) return;

        var key = propertyKey(field.name);
        if (!key) return;
        if (prefix && key.indexOf(prefix) === 0) key = key.slice(prefix.length);

        var value = field.value;
        if (value === null || value === '') return;

        properties[key] = value;
      });

      return properties;
    }

    submit(index) {
      var panel = this.panel(index);
      var variant = this.match(index);
      if (!variant || !panel) return;

      if (panel.dataset.inherit === 'true' && !this.parentReady()) {
        var form = this.form();
        this.setError(panel, panel.dataset.emptyMessage || 'Finish the required fields above first, then add this.');
        if (form && typeof form.reportValidity === 'function') form.reportValidity();
        return;
      }

      this.addToCart(index, variant.id);
    }

    announce(cart, sections) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'also-add',
          data: {
            source: 'also-add',
            itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : 0,
            sections: sections || {}
          }
        }
      }));
    }

    addToCart(index, variantId) {
      var self = this;
      var panel = this.panel(index);
      var button = panel.querySelector('[data-also-add-submit]');
      if (button) button.setAttribute('aria-busy', 'true');
      this.setError(panel, '');

      var sections = cartSectionIds();
      var payload = {
        items: [{ id: variantId, quantity: 1, properties: this.collect(panel) }]
      };
      if (sections.length) {
        payload.sections = sections.join(',');
        payload.sections_url = window.location.pathname;
      }

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) throw new Error(body && body.description ? body.description : 'add failed');
            return body;
          });
        })
        .then(function (added) {
          /* Vanaf hier is het product toegevoegd. Wat hierna misgaat is een
             weergaveprobleem en mag niet als mislukte toevoeging lezen. */
          self.markAdded(index);
          panel.hidden = true;
          self.setOpen(index, false);

          return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (response) { return response.json(); })
            .then(function (cart) { self.announce(cart, added.sections); })
            .catch(function (error) { console.error('also-add: cart refresh failed', error); });
        })
        .catch(function (error) {
          self.setError(panel, (error && error.message) ? error.message : 'Something went wrong. Please try again.');
          panel.hidden = false;
          self.setOpen(index, true);
        })
        .finally(function () {
          if (button) button.removeAttribute('aria-busy');
        });
    }
  }

  customElements.define('also-add', AlsoAdd);
})();